import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=644fefef&scoped=true&"
import script from "./bus.vue?vue&type=script&lang=js&"
export * from "./bus.vue?vue&type=script&lang=js&"
import style0 from "./bus.vue?vue&type=style&index=0&id=644fefef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fefef",
  null
  
)

export default component.exports